var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11898 17.78C6.13898 17.82 6.15899 17.84 6.17899 17.86C6.259 17.96 6.35902 18 6.47904 18C6.59907 18 6.71909 17.98 6.81911 17.86C6.83911 17.84 6.87912 17.8 6.87912 17.76C8.21936 15.7596 9.5396 13.7592 10.8398 11.7389C11.66 10.4586 12.6202 9.19839 12.8802 7.67812C13.2003 5.85779 12.7602 3.97744 11.64 2.51718C9.41958 -0.403356 5.09879 -0.843436 2.29828 1.51699C0.958038 2.6372 0.137889 4.2775 0.017867 6.01781C-0.122159 7.85815 0.577969 9.25841 1.51814 10.7587C2.99841 13.1191 4.55869 15.4595 6.11898 17.78ZM1.61816 3.53736C3.53851 0.336779 8.11934 -0.123305 10.6598 2.59719C11.92 3.95744 12.4401 5.89779 12.0601 7.69812C11.78 9.03837 10.8398 10.2386 10.0997 11.3788C8.91949 13.2391 7.71927 15.0595 6.49905 16.8798C5.45886 15.3595 4.43867 13.8192 3.43849 12.279C2.75837 11.2388 2.05824 10.1786 1.45813 9.09838C0.497955 7.39807 0.617976 5.19767 1.61816 3.53736Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49879 9.43849C8.01906 9.43849 9.25929 8.19826 9.25929 6.67798C9.25929 5.15771 8.01906 3.91748 6.49879 3.91748C4.97851 3.91748 3.73828 5.15771 3.73828 6.67798C3.73828 8.21826 4.97851 9.43849 6.49879 9.43849ZM6.49879 4.75763C7.55898 4.75763 8.43914 5.61779 8.43914 6.69799C8.43914 7.75818 7.57898 8.63834 6.49879 8.63834C5.43859 8.63834 4.55843 7.77818 4.55843 6.69799C4.55843 5.61779 5.41859 4.75763 6.49879 4.75763Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4d8553404d3e67d41ff96cdb7d1a0a93.svg";
export { ForwardRef as ReactComponent };